import { createSelector } from '@reduxjs/toolkit';
import { selectStrategyCompositionState } from '../../store/selectors';

export const strategyComposition = createSelector(selectStrategyCompositionState, (state) => state.strategyComposition);
export const selectedVersion = createSelector(selectStrategyCompositionState, (state) => state.parameters.selectedVersion);
export const versions = createSelector(selectedVersion, (state) => state?.strategyVersionCompositionItems);
